<template>
	<div class="login-box">
	  <div class="login-logo">
			<img src="images/Logo_LaborTIME_Azul.png" alt="LaborTIME" style="width: 200px;" />
	  </div>
	  <!-- /.login-logo -->
	  <el-card class="box-card">
	    <p class="login-box-msg">Ingrese para comenzar la sesión</p>

        <el-form :model="resource" @submit.prevent="signin">
			<el-form-item v-if="error"> 
				<el-alert
				:closable="false"
				title="Error: E-mail o contraseña incorrectos"
				type="error"
				show-icon>
				</el-alert>
			</el-form-item>

			<el-form-item 
				style="margin-bottom: 25px !important;"
				prop="email"
				:rules="[
  					{required: true, message: 'Escriba su E-mail'},
  					{ type: 'email', message: 'Escriba una dirección de E-mail válida'}
  				]"
  			>
				<el-input placeholder="E-mail" v-model="resource.email"></el-input>
			</el-form-item>
			<el-form-item 
				style="margin-bottom: 25px !important;"
				prop="password"
				:rules="[
  					{required: true, message: 'Escriba su contraseña'}
  				]"
  			>
				<el-input type="password" placeholder="Contraseña" v-model="resource.password" auto-complete="off"></el-input>
			</el-form-item>

	      <div class="row">
	      <small>* si tiene problemas para ingresar con su usuario u olvidó su contraseña, comuníquese con el administrador del sistema en su empresa.</small>
	      </div>
	      <div class="row">
	        <div class="col-xs-8">
	         <!--  <div class="checkbox icheck">
	            <label>
	              <input type="checkbox"> Recordarme
	            </label>
	          </div> -->
	        </div>
	        <!-- /.col -->
	        <div class="col-xs-4">
	        <el-button type="primary" @click="signin" native-type="submit">Ingresar</el-button>
	        </div>
	        <!-- /.col -->
	      </div>
	    </el-form>

	    <!-- <a href="#">Olvidé mi contraseña</a><br> -->
	  </el-card>

		<div style="text-align: right;">
			<img src="images/Logo_SAISE_horizontal.png" alt="SAISE-IS" style="width: 80px; margin-top: 20px;" />
		</div>

	  <!-- /.login-box-body -->
	</div>
	<!-- /.login-box -->
</template>

<script>
    export default {
    	data() {
            return {
            	resource: {
	                email: null,
	                password: null,
	            },
              error: false
            }
        },
        methods: {
            signin(event) {
                event.preventDefault();
                this.$auth.signin(this, this.resource.email, this.resource.password);
            }
        }
    }
</script>